import React from "react";

const ExternalLink = ({ size = 20, ...rest }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 25 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="arrow-narrow-up-right">
                <path
                    id="Icon"
                    d="M6.5 18L18.5 6M18.5 6H10.5M18.5 6V14"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default ExternalLink;
